(function () {
  'use strict';

  window.__melindasA11yCookieHardeningVersion = '2026-05-18-av99-followup';

  var BANNER_SELECTORS = [
    '#shopify-pc__banner',
    '.shopify-pc__banner',
    '.shopify-privacy-banner',
    '[id*="cookie-banner"]',
    '[class*="cookie-banner"]'
  ].join(',');
  var INTERACTIVE_SELECTOR = [
    'button',
    'a[href]',
    'input',
    'select',
    'textarea',
    '[role="button"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function lowerText(value) {
    return cleanText(value).toLowerCase();
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isVisuallyHidden(element) {
    if (!element) return true;
    var className = typeof element.className === 'string' ? element.className : '';
    if (/\b(sr-only|visually-hidden|screen-reader)\b/i.test(className)) return true;
    var style = window.getComputedStyle(element);
    if (style.clip !== 'auto' || style.clipPath !== 'none') return true;
    var rect = element.getBoundingClientRect();
    return rect.width <= 2 && rect.height <= 2;
  }

  function ensureId(element, fallback) {
    if (!element.id) {
      element.id = fallback + '-' + Math.random().toString(36).slice(2, 8);
    }
    return element.id;
  }

  function getBanner() {
    var preferred = document.getElementById('shopify-pc__banner');
    if (preferred) return preferred;

    var candidates = document.querySelectorAll(BANNER_SELECTORS);
    for (var i = 0; i < candidates.length; i += 1) {
      if (candidates[i].querySelector && candidates[i].querySelector(INTERACTIVE_SELECTOR)) {
        return candidates[i];
      }
    }
    return null;
  }

  function ensureAssistiveLandmarks() {
    var body = document.body;
    if (!body) return;

    var startScript = document.getElementById('usntA42start');
    if (startScript) {
      startScript.setAttribute('data-a42-container', 'usableNetAssistive');
    }

    var container = document.getElementById('usableNetAssistive');
    if (!container) {
      container = document.createElement('div');
      container.id = 'usableNetAssistive';
      container.setAttribute('role', 'complementary');
      container.setAttribute('aria-label', 'Accessibility options');
    }

    var skipLink = document.querySelector('a.skip-to-content[href="#MainContent"]');
    if (skipLink) {
      skipLink.textContent = 'Skip to main content';
      if (container.parentNode !== body || container.nextSibling !== skipLink) {
        body.insertBefore(container, skipLink);
      }
    } else if (container.parentNode !== body) {
      body.insertBefore(container, body.firstChild);
    }

    var main = document.getElementById('MainContent');
    if (main) {
      main.setAttribute('role', 'main');
    }
  }

  function installHardeningStyles() {
    var style = document.getElementById('a11y-cookie-banner-hardening-styles');
    if (style && style.getAttribute('data-a11y-hardening-version') === '2026-05-18-av99-followup') return;

    if (!style) {
      style = document.createElement('style');
      style.id = 'a11y-cookie-banner-hardening-styles';
    }

    style.id = 'a11y-cookie-banner-hardening-styles';
    style.setAttribute('data-a11y-hardening-version', '2026-05-18-av99-followup');
    style.textContent = [
      '#shopify-pc__banner .a11y-cookie-controls {',
      '  display: grid !important;',
      '  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;',
      '  gap: 12px !important;',
      '  min-width: 0 !important;',
      '  width: 100% !important;',
      '}',
      '@media (max-width: 640px) {',
      '  #shopify-pc__banner .a11y-cookie-controls {',
      '    grid-template-columns: 1fr !important;',
      '  }',
      '',
      '  #shopify-pc__banner {',
      '    max-height: calc(100vh - 16px) !important;',
      '    overflow-y: auto !important;',
      '    overscroll-behavior: contain !important;',
      '    top: 8px !important;',
      '    bottom: auto !important;',
      '  }',
      '}',
      '@media (max-width: 400px), (max-height: 320px) {',
      '  #shopify-pc__prefs__overlay {',
      '    align-items: stretch !important;',
      '    box-sizing: border-box !important;',
      '    display: flex !important;',
      '    height: 100vh !important;',
      '    justify-content: center !important;',
      '    overflow: hidden !important;',
      '    padding: 8px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog {',
      '    box-sizing: border-box !important;',
      '    inset: auto !important;',
      '    left: auto !important;',
      '    margin: 0 !important;',
      '    max-height: calc(100vh - 16px) !important;',
      '    max-width: calc(100vw - 16px) !important;',
      '    overflow-x: hidden !important;',
      '    overflow-y: auto !important;',
      '    position: relative !important;',
      '    right: auto !important;',
      '    top: auto !important;',
      '    transform: none !important;',
      '    width: calc(100vw - 16px) !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog header,',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__intro,',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__option {',
      '    box-sizing: border-box !important;',
      '    padding-left: 16px !important;',
      '    padding-right: 16px !important;',
      '    width: 100% !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog header {',
      '    padding-bottom: 12px !important;',
      '    padding-top: 12px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__header-title {',
      '    font-size: 16px !important;',
      '    letter-spacing: 0 !important;',
      '    line-height: 1.2 !important;',
      '    margin-bottom: 8px !important;',
      '    max-width: calc(100% - 48px) !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__header-close {',
      '    height: 44px !important;',
      '    min-height: 44px !important;',
      '    position: absolute !important;',
      '    right: 12px !important;',
      '    top: 12px !important;',
      '    width: 44px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs #shopify-pc__prefs__header-close {',
      '    height: 44px !important;',
      '    min-height: 44px !important;',
      '    min-width: 44px !important;',
      '    width: 44px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions {',
      '    display: grid !important;',
      '    gap: 6px !important;',
      '    grid-template-columns: 1fr !important;',
      '    margin: 0 !important;',
      '    width: 100% !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions button {',
      '    margin: 0 !important;',
      '    min-height: 44px !important;',
      '    width: 100% !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__option p {',
      '    box-sizing: border-box !important;',
      '    margin-left: 36px !important;',
      '    max-width: calc(100% - 36px) !important;',
      '    width: auto !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog * {',
      '    max-width: 100% !important;',
      '  }',
      '',
      '  body.a11y-cookie-ui-open #usableNetAssistive,',
      '  body.a11y-cookie-ui-open #usntA42Link,',
      '  body.a11y-cookie-ui-open .c-launchBubble-button {',
      '    opacity: 0 !important;',
      '    pointer-events: none !important;',
      '    visibility: hidden !important;',
      '  }',
      '}'
    ].join('\n');
    if (!style.parentNode) {
      document.head.appendChild(style);
    }
  }

  function headingCandidates(banner) {
    return Array.prototype.slice.call(
      banner.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, [role="heading"], #shopify-pc__banner__body-title, .shopify-pc__banner__body-title'
      )
    ).filter(function (heading) {
      return /^cookie consent$/i.test(cleanText(heading.textContent));
    });
  }

  function ensureBannerHeading(banner) {
    var headings = headingCandidates(banner);
    var visibleHeading = headings.filter(function (heading) {
      return !isVisuallyHidden(heading);
    })[0];

    if (!visibleHeading) {
      visibleHeading = headings[0];
    }

    if (!visibleHeading) {
      visibleHeading = document.createElement('h2');
      visibleHeading.className = 'sr-only';
      visibleHeading.textContent = 'Cookie consent';
      visibleHeading.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
      banner.insertBefore(visibleHeading, banner.firstChild);
    }

    headings.forEach(function (heading) {
      if (heading !== visibleHeading) {
        heading.remove();
      }
    });

    if (!/^H[1-6]$/i.test(visibleHeading.tagName) && !visibleHeading.getAttribute('role')) {
      visibleHeading.setAttribute('role', 'heading');
      visibleHeading.setAttribute('aria-level', '2');
    }

    banner.setAttribute('role', 'alertdialog');
    banner.setAttribute('aria-labelledby', ensureId(visibleHeading, 'cookie-banner-heading'));
    banner.removeAttribute('aria-label');

    var description = banner.querySelector('.shopify-pc__banner__body p, p');
    if (description) {
      banner.setAttribute('aria-describedby', ensureId(description, 'cookie-banner-desc'));
    }
  }

  function looksLikeCookieButtonGroup(element) {
    var text = lowerText(element.textContent);
    var nestedText = Array.prototype.slice.call(element.querySelectorAll(INTERACTIVE_SELECTOR)).map(function (child) {
      return [
        child.id,
        child.className,
        child.getAttribute('aria-label'),
        child.textContent
      ].join(' ');
    }).join(' ');
    var signature = lowerText(text + ' ' + nestedText);

    return signature.indexOf('accept') !== -1 &&
      signature.indexOf('decline') !== -1 &&
      (signature.indexOf('cookie preferences') !== -1 ||
        signature.indexOf('manage preferences') !== -1);
  }

  function hasNestedCookieControls(element) {
    var nestedInteractive = Array.prototype.slice.call(element.querySelectorAll(INTERACTIVE_SELECTOR)).filter(function (child) {
      return child !== element;
    });

    if (nestedInteractive.length < 2) return false;
    return looksLikeCookieButtonGroup(element);
  }

  function legacyLooksLikeCookieButtonGroup(element) {
    var text = lowerText(element.textContent);
    return text.indexOf('cookie preferences') !== -1 &&
      text.indexOf('accept') !== -1 &&
      text.indexOf('decline') !== -1;
  }

  function copySafeAttributes(from, to) {
    Array.prototype.slice.call(from.attributes).forEach(function (attr) {
      if (/^(class|role|tabindex|type|name|value|disabled|aria-label|aria-labelledby|aria-pressed|aria-expanded|aria-haspopup)$/i.test(attr.name)) {
        return;
      }
      to.setAttribute(attr.name, attr.value);
    });
  }

  function replaceWithNeutralGroup(element) {
    var replacement = document.createElement('div');
    copySafeAttributes(element, replacement);
    replacement.className = 'a11y-cookie-controls';
    replacement.setAttribute('data-a11y-original-class', element.getAttribute('class') || '');
    while (element.firstChild) {
      replacement.appendChild(element.firstChild);
    }
    element.parentNode.replaceChild(replacement, element);
    return replacement;
  }

  function neutralizeInvalidButtonGroup(element) {
    if (!element || (!hasNestedCookieControls(element) && !legacyLooksLikeCookieButtonGroup(element))) return null;

    var nestedInteractive = Array.prototype.slice.call(element.querySelectorAll(INTERACTIVE_SELECTOR)).filter(function (child) {
      return child !== element;
    });
    if (nestedInteractive.length < 2) return element;

    if (element.tagName === 'BUTTON' || /\bshopify-pc__banner__btns\b/i.test(element.className || '')) {
      return replaceWithNeutralGroup(element);
    }

    element.removeAttribute('role');
    element.removeAttribute('tabindex');
    element.removeAttribute('aria-label');
    element.removeAttribute('aria-labelledby');
    return element;
  }

  function removeInvalidButtonGroups(root) {
    Array.prototype.slice.call(root.querySelectorAll('button, [role="button"]')).forEach(function (element) {
      neutralizeInvalidButtonGroup(element);
    });
  }

  function labelCookieControls(root) {
    Array.prototype.slice.call(root.querySelectorAll('button, [role="button"], a')).forEach(function (control) {
      if (!isVisible(control)) return;
      if (hasNestedCookieControls(control)) return;
      var signature = lowerText([
        control.id,
        control.className,
        control.getAttribute('aria-label'),
        control.textContent
      ].join(' '));

      if (/manage|preferences/.test(signature)) {
        control.setAttribute('aria-label', 'Cookie preferences');
      } else if (/accept|allow|agree/.test(signature)) {
        control.setAttribute('aria-label', 'Accept cookies');
      } else if (/decline|reject|deny/.test(signature)) {
        control.setAttribute('aria-label', 'Decline cookies');
      }
    });
  }

  function ensureRequiredNote(root) {
    var existing = document.getElementById('shopify-pc-a11y-required-note');
    if (existing) return existing;

    var note = document.createElement('span');
    note.id = 'shopify-pc-a11y-required-note';
    note.className = 'sr-only';
    note.textContent = 'Required cookies, always active';
    note.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
    root.appendChild(note);
    return note;
  }

  function appendDescribedBy(element, id) {
    var current = cleanText(element.getAttribute('aria-describedby'));
    var parts = current ? current.split(/\s+/) : [];
    if (parts.indexOf(id) === -1) {
      parts.push(id);
      element.setAttribute('aria-describedby', parts.join(' '));
    }
  }

  function fixRequiredState() {
    var prefs = document.getElementById('shopify-pc__prefs');
    if (!prefs) return;

    var note = ensureRequiredNote(prefs);
    Array.prototype.slice.call(prefs.querySelectorAll('*')).forEach(function (element) {
      var text = lowerText(element.textContent);
      if (text === 'required' || text === 'always active') {
        element.setAttribute('aria-label', 'Required cookies, always active');
        var owner = element.closest('button, [role="switch"], [role="checkbox"], label, input');
        if (owner) {
          owner.setAttribute('aria-disabled', 'true');
          appendDescribedBy(owner, note.id);
        }
      }
    });

    Array.prototype.slice.call(prefs.querySelectorAll('[disabled], [aria-disabled="true"]')).forEach(function (control) {
      appendDescribedBy(control, note.id);
    });
  }

  function getEnableAccessibilityControl() {
    return document.getElementById('usntA42Link') ||
      document.querySelector('#usableNetAssistive button, #usableNetAssistive a, [data-a42-container] button');
  }

  function isCookieSurfaceVisible() {
    var banner = getBanner();
    var prefs = document.getElementById('shopify-pc__prefs') ||
      document.getElementById('shopify-pc__prefs__dialog');
    return isVisible(banner) || isVisible(prefs);
  }

  var focusRestorePending = false;
  var focusRestoreAttempts = 0;
  var cookieSurfaceWasVisible = false;

  function focusAssistiveControlIfReady() {
    if (isCookieSurfaceVisible()) return false;

    var control = getEnableAccessibilityControl();
    if (!control || !isVisible(control)) return false;

    if (!control.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/i.test(control.tagName)) {
      control.setAttribute('tabindex', '0');
    }

    try {
      control.focus({ preventScroll: true });
    } catch (error) {
      control.focus();
    }

    return document.activeElement === control;
  }

  function queueAssistiveFocusRestore() {
    [100, 500, 1500, 3000, 6000].forEach(function (delay) {
      window.setTimeout(focusAssistiveControlIfReady, delay);
    });
  }

  function redirectSkipLinkFocusToAssistiveControl() {
    var active = document.activeElement;
    if (!active || !active.matches || !active.matches('a.skip-to-content[href="#MainContent"]')) return;
    focusAssistiveControlIfReady();
  }

  function restoreFocusToAssistiveControl() {
    if (!focusRestorePending) return;

    if (isCookieSurfaceVisible() && focusRestoreAttempts < 80) {
      focusRestoreAttempts += 1;
      window.setTimeout(restoreFocusToAssistiveControl, 100);
      return;
    }

    if (isCookieSurfaceVisible()) return;

    focusRestorePending = false;
    focusRestoreAttempts = 0;

    focusAssistiveControlIfReady();
  }

  function isCookieCloseControl(target) {
    if (!target || !target.closest) return false;

    var control = target.closest('button, [role="button"], a');
    if (!control) return false;

    var inCookieUi = control.closest('#shopify-pc__banner, #shopify-pc__prefs, #shopify-pc__prefs__dialog');
    if (!inCookieUi) return false;

    var signature = lowerText([
      control.id,
      control.className,
      control.getAttribute('aria-label'),
      control.textContent
    ].join(' '));

    if (/manage|preferences/.test(signature) && !/save|close|accept|decline|reject/.test(signature)) {
      return false;
    }

    return /accept|allow|agree|decline|reject|deny|save|close/.test(signature);
  }

  function scheduleFocusRestoreFromCookieClose(target) {
    if (!isCookieCloseControl(target)) return;

    focusRestorePending = true;
    focusRestoreAttempts = 0;
    window.setTimeout(restoreFocusToAssistiveControl, 100);
    queueAssistiveFocusRestore();
  }

  function syncCookieSurfaceState() {
    var visible = isCookieSurfaceVisible();

    if (document.body) {
      document.body.classList.toggle('a11y-cookie-ui-open', visible);
    }

    if (cookieSurfaceWasVisible && !visible) {
      focusRestorePending = true;
      focusRestoreAttempts = 0;
      queueAssistiveFocusRestore();
    }

    cookieSurfaceWasVisible = visible;
  }

  function hardenCookieBanner() {
    var banner = getBanner();
    if (!banner) return;

    ensureBannerHeading(banner);
    removeInvalidButtonGroups(banner);
    labelCookieControls(banner);
  }

  var scheduled = false;
  function scheduleHardening() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      installHardeningStyles();
      ensureAssistiveLandmarks();
      hardenCookieBanner();
      fixRequiredState();
      syncCookieSurfaceState();
      restoreFocusToAssistiveControl();
      redirectSkipLinkFocusToAssistiveControl();
    }, 25);
  }

  document.addEventListener('click', function (event) {
    scheduleFocusRestoreFromCookieClose(event.target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    scheduleFocusRestoreFromCookieClose(event.target);
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    scheduleFocusRestoreFromCookieClose(event.target);
  }, true);

  document.addEventListener('focusin', redirectSkipLinkFocusToAssistiveControl, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHardening);
  } else {
    scheduleHardening();
  }

  window.setInterval(scheduleHardening, 250);

  var observer = new MutationObserver(scheduleHardening);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'role', 'aria-label', 'aria-labelledby', 'tabindex']
  });
})();
